import { ROLE } from 'api/config';

const setIsModuleDefault = (isModule) => {
  return isModule != null ? isModule : true;
};
export const permissionRole = () => {
  return {
    facility: {
      view: true,
      write: true,
      delete: true,
      isVisible: true,
    },
    facilityInspection: {
      view: true,
      write: true,
      delete: true,
      isVisible: true,
    },
    facilityAudit: {
      view: true,
      write: true,
      delete: true,
      isVisible: setIsModuleDefault(ROLE().isModuleFacilityAudit),
    },
    facilityPermit: {
      view: true,
      write: true,
      delete: true,
      isVisible: true,
    },
    biodiversity: {
      view: true,
      write: true,
      delete: true,
      isVisible:  setIsModuleDefault(ROLE().isModuleBiodiversity),
    },
    facilityEmission: {
      view: true,
      write: true,
      delete: true,
      isVisible: setIsModuleDefault(ROLE().isModuleEmission),
    },
    map: {
      view: true,
      isVisible: setIsModuleDefault(ROLE().isModuleMap),
    },
    facilityeia: {
      view: true,
      write: true,
      delete: true,
      isVisible: setIsModuleDefault(ROLE().isModuleFacilityeia),
    },
    facilityDevice: {
      view: true,
      write: true,
      delete: true,
      isVisible: setIsModuleDefault(ROLE().isModuleFacilityDevice),
    },
    environmentProtectionWork: {
      view: true,
      write: true,
      delete: true,
      isVisible: setIsModuleDefault(ROLE().isModuleEnvironmentProtectionWork),

    },
    facilityHazarWasteReport: {
      view: true,
      write: true,
      delete: true,
      isVisible: setIsModuleDefault(ROLE().isModuleWasteReport),
    },
    legalDocument: {
      view: true,
      write: true,
      delete: true,
      isVisible: setIsModuleDefault(ROLE().isModuleLegalDocument),
    },
    manage: {
      full: true,
      isVisible: true,
    },
    admin: {
      full: true,
      isVisible: true,
    },
  };
};

export const moduleName = {
  facility: 'Cơ sở',
  facilityInspection: 'Thanh tra',
  facilityAudit: 'Kiểm tra',
  facilityPermit: 'Giấy phép',
  biodiversity: 'Đa dạng sinh học',
  facilityEmission: 'Quản lý ô nhiễm',
  map: 'Bản đồ',
  facilityeia: 'Hồ sơ môi trường',
  facilityDevice: 'Quản lý thiết bị',

  environmentProtectionWork: 'BC Công tác BVMT',

  facilityHazarWasteReport: 'BC Chất thải nguy hại',
  legalDocument: 'Văn bản pháp lý',
  manage: 'Quản lý',
  admin: 'Quản trị',
};

export const permissionRoleName = {
  'facility.view': 'Xem',
  'facility.write': 'Thêm mới/Sửa',
  'facility.delete': 'Xoá',

  'facilityInspection.view': 'Xem',
  'facilityInspection.write': 'Thêm mới/Sửa',
  'facilityInspection.delete': 'Xoá',

  'facilityAudit.view': 'Xem',
  'facilityAudit.write': 'Thêm mới/Sửa',
  'facilityAudit.delete': 'Xoá',

  'facilityPermit.view': 'Xem',
  'facilityPermit.write': 'Thêm mới/Sửa',
  'facilityPermit.delete': 'Xoá',

  'biodiversity.view': 'Xem',
  'biodiversity.write': 'Thêm mới/Sửa',
  'biodiversity.delete': 'Xoá',

  'facilityEmission.view': 'Xem',
  'facilityEmission.write': 'Thêm mới/Sửa',
  'facilityEmission.delete': 'Xoá',

  'map.view': 'Xem',

  'facilityeia.view': 'Xem',
  'facilityeia.write': 'Thêm mới/Sửa',
  'facilityeia.delete': 'Xoá',

  'facilityDevice.view': 'Xem',
  'facilityDevice.write': 'Thêm mới/Sửa',
  'facilityDevice.delete': 'Xoá',

  'environmentProtectionWork.view': 'Xem',
  'environmentProtectionWork.write': 'Thêm mới/Sửa',
  'environmentProtectionWork.delete': 'Xoá',

  'legalDocument.view': 'Xem',
  'legalDocument.write': 'Thêm mới/Sửa',
  'legalDocument.delete': 'Xoá',

  'facilityHazarWasteReport.view': 'Xem',
  'facilityHazarWasteReport.write': 'Thêm mới/Sửa',
  'facilityHazarWasteReport.delete': 'Xoá',

  'manage.full': 'Xem/Thêm mới/Sửa/Xoá',

  'admin.full': 'Xem/Thêm mới/Sửa/Xoá',
};

export const roleArr = [
  {
    Name: 'Bạn đọc',
    Key: 'GUEST',
  },
  {
    Name: 'Quận người dùng',
    Key: 'DISTRICT_USER',
  },
  {
    Name: 'Tỉnh EPA/EMC người dùng',
    Key: 'PROVINCE_USER',
  },
  {
    Name: 'Quản trị hệ thống',
    Key: 'ADMIN',
  },
  {
    Name: 'PRTR',
    Key: 'PRTR_USER_DOANHNGHIEP',
  },
];



// WEBPACK FOOTER //
// ./src/constants/role.js